import { createFileRoute, Outlet, useNavigate } from '@tanstack/react-router';
import { useEffect } from 'react';
import { AdminLayout } from '../components/layout/admin-layout';
import { useAuth } from '../contexts/useAuth';
import { useCurrentUser } from '@pantry/api-client';
import { hasAppPermission } from '@pantry/shared';

export const Route = createFileRoute('/admin')({
  component: AdminLayoutWrapper,
});

function AdminLayoutWrapper() {
  const { session, isLoading: authLoading } = useAuth();
  const navigate = useNavigate();
  const { data: user, isLoading: userLoading } = useCurrentUser();

  const isLoading = authLoading || userLoading;

  useEffect(() => {
    // Redirect to login if not authenticated
    if (!authLoading && !session) {
      navigate({ to: '/login' });
      return;
    }

    // Redirect to dashboard if user doesn't have admin access
    if (!userLoading && user && !hasAppPermission(user.appRole, 'app:users:view')) {
      navigate({ to: '/dashboard' });
    }
  }, [session, authLoading, user, userLoading, navigate]);

  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <div className="h-8 w-8 animate-spin rounded-full border-4 border-primary border-t-transparent" />
      </div>
    );
  }

  if (!session) {
    return null;
  }

  // Check if user has admin access
  if (!user || !hasAppPermission(user.appRole, 'app:users:view')) {
    return null;
  }

  return (
    <AdminLayout>
      <Outlet />
    </AdminLayout>
  );
}
